import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { balanceApi } from '../../api/balance';
import type { BalanceResponse } from '../../types/balance.types';

interface BalanceState {
  data: BalanceResponse | null;
  status: 'idle' | 'loading' | 'error';
}

const initialState: BalanceState = {
  data: null,
  status: 'idle',
};

export const fetchBalance = createAsyncThunk(
  'balance/fetch',
  () => balanceApi.getBalance(),
  {
    condition: (_, { getState }) => {
      const state = getState() as { balance: { status: string } };
      return state.balance.status !== 'loading';
    },
  }
);

const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalance.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBalance.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = 'idle';
      })
      .addCase(fetchBalance.rejected, (state) => {
        state.status = 'error';
      });
  },
});

export default balanceSlice.reducer;
